import React from 'react';

export default function AboutUs() {
  return (
    <section className="section" id="about">
      <h3 className="section-title">About Us</h3>
      <p className="about-text-center">
        RT 17 adalah salah satu Rukun Tetangga yang berada di Kelurahan Karang Joang, Kecamatan Balikpapan Utara, Kalimantan Timur. Kami adalah komunitas warga yang menjunjung tinggi nilai kebersamaan, gotong royong, dan keharmonisan dalam kehidupan sehari-hari.

Dengan semangat saling mendukung, RT 17 berkomitmen untuk menciptakan lingkungan yang aman, nyaman, dan aktif. Berbagai fasilitas umum seperti posyandu, masjid, dan area olahraga kami sediakan demi kesejahteraan warga. Selain itu, wilayah kami juga memiliki potensi wisata lokal yang menarik dan terus kami kembangkan bersama masyarakat.
      </p>
    </section>
  );
}
